import { render } from "./EmoticonFace4.vue?vue&type=template&id=6845edfa&ts=true"
import script from "./EmoticonFace4.vue?vue&type=script&lang=ts"
export * from "./EmoticonFace4.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__